import { InputSelect, InputWrapper } from '@vrplatform/components';
import type { SelectItem } from '@vrplatform/components';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { type FeeFormInputs, useFeeForm } from '../useFeeForm';

export const FeeTriggerEditor = () => {
  const methods = useFeeForm();
  // const trigger = methods.watch('trigger');

  // const isCron = trigger === 'schedule';

  const options = useMemo<SelectItem<FeeFormInputs['revenueRecognition']>[]>(
    () => [
      {
        label: 'Booked At',
        value: 'bookedAt',
        description: 'The date the reservation was booked at',
      },
      {
        label: 'Check-in',
        value: 'checkIn',
        description: 'The Check-in date of the reservation',
      },
      {
        label: 'Check-out',
        value: 'checkOut',
        description: 'The Check-out date of the reservation',
      },
      // {
      //   label: 'Cancelled At',
      //   value: 'cancelledAt',
      //   description:
      //     'If no cancellation date is available, it will default to the bookedat date',
      // },
      {
        label: 'Pro Rata',
        value: 'proRata',
        description: 'Revenue is recognized evenly across the entire stay',
      },
    ],
    []
  );

  return (
    <>
      {/* <Controller
        control={methods.control}
        name="trigger"
        rules={{
          validate: (value) => value.trim().length > 0 || 'Trigger is required',
        }}
        render={({ field, fieldState }) => {
          const options = useMemo<
            SelectItem<ManagementCommissionFormInputs['trigger']>[]
          >(
            () => [
              { label: 'Every Reservation', value: 'reservation' },
              { label: 'On set schedule', value: 'schedule' },
            ],
            []
          );

          const value =
            options.find((option) => option.value === field.value) || null;

          return (
            <Box maw={200} sx={{ flex: 1 }}>
              <InputWrapper error={fieldState.error?.message}>
                <InputSelect
                  value={value}
                  setValue={(value) => {
                    if (!value?.value) return;

                    field.onChange(value?.value);
                    if (value?.value === 'reservation') {
                      methods.setValue('triggerValue', 'booked');
                    } else {
                      methods.setValue('triggerValue', '0 0 * * *');
                    }
                  }}
                  type="single"
                  inputProps={{
                    error: !!fieldState.error,
                    width: 200,
                  }}
                  dropdownProps={{
                    width: 'target',
                  }}
                  data={{
                    options,
                  }}
                />
              </InputWrapper>
            </Box>
          );
        }}
      /> */}

      <Controller
        control={methods.control}
        name="revenueRecognition"
        rules={{
          validate: (value) =>
            (value?.trim().length || 0) > 0 || 'Schedule is required',
        }}
        render={({ field, fieldState }) => {
          // if (isCron) {
          //   return (
          //     <InputWrapper error={fieldState.error?.message}>
          //       {/* <Input {...field} error={!!fieldState.error} /> */}
          //       <Box mt={-25}>
          //         <Cron
          //           value={field.value}
          //           setValue={field.onChange}
          //           clearButton={false}
          //         />
          //       </Box>
          //     </InputWrapper>
          //   );
          // }

          const value =
            options.find((option) => option.value === field.value) || null;

          return (
            <InputWrapper error={fieldState.error?.message}>
              <InputSelect
                value={value}
                setValue={(value) =>
                  value?.value && field.onChange(value?.value)
                }
                type="single"
                inputProps={{
                  error: !!fieldState.error,
                  disabled: field.disabled,
                }}
                data={{
                  options,
                }}
              />
            </InputWrapper>
          );
        }}
      />
    </>
  );
};
